<div class="notifications">
  <div class="notifications__top">
    <div class="notifications__top--inner">
      <div class="notifications__title">{{'t.notifications' | translate}}</div>
      @if (lists.length) {
        <span class="notifications__count" [ngClass]="{'opened': notifyService?.isNotUnique || notifyService?.isOpened}">{{lists.length}}</span>
      }
    </div>
    <i (click)="notifyService.close()" class="icon-close"></i>
  </div>
  <div class="notifications__list">
    @if (!lists.length) {
      <div class="notifications__empty">
        {{'t.notifications-empty' | translate}}
      </div>
    }
    @for (notify of lists; track $index) {
      <app-notification-item [notify]="notify"></app-notification-item>
    }
  </div>
</div>
